/* global dwolla  */
import React, {
  useState, useCallback, useEffect,
} from 'react';
import { css } from 'styled-components';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { getIAVToken } from '../../helpers/API';
import Loader from '../Loader';
import CreditCard from '../CreditCard';
import {
  DwollaContainer, Image, Container,
} from './styled';
import { getDwollaTokenFromUI } from './helpers';
import CloseIcon from './CloseIcon.svg';

const fullScreenCss = css`
  position: absolute;
  height: 100%;
  width: 100%;
  background-color: white;
  top: 0;
  left: 0;
  z-index: 1;
`;

function Dwolla({
  next, submit: _submit, firstName, lastName,
  email, cancel, showCardOnSubmit,
  onToken = () => { },
}) {
  const [view, setView] = useState(null);
  const [token, setToken] = useState('');
  const mobileMediaQuery = useMediaQuery('(max-width:500px)');
  const [fullscreen, setFullscreen] = useState(false);
  const [loading, setLoading] = useState(true);
  const submit = useCallback(() => {
    _submit({
      achToken: token,
      firstName,
      lastName,
      processorType: 'dwolla',
      paymentType: 'ach',
    });
  }, [_submit, firstName, lastName, token]);
  const startDwollaUI = useCallback(function (IAVToken) {
    setLoading(false);
    dwolla.configure(process.env.GATSBY_DWOLLA_ENV);

    if (IAVToken && $('#iav-container')) {
      getDwollaTokenFromUI(IAVToken, 'iav-container', fullscreen, setFullscreen, (token) => {
        if (showCardOnSubmit && view !== 'show-card') {
          const { achToken } = token;
          setToken(achToken);
          onToken({
            token: achToken,
            paymentType: 'ach',
          });
          setView('show-card');
        } else {
          _submit(token);
        }
      });
    }
  }, [fullscreen, onToken, showCardOnSubmit, _submit, view]);

  useEffect(() => {
    if (firstName && lastName && email) {
      getIAVToken(firstName, lastName, email).then(startDwollaUI);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [email, firstName, lastName]);

  if (view === 'show-card') {
    return (
      <DwollaContainer onSubmit={() => submit({ achToken: token })} as="form">
        <CreditCard last4={token.slice(-4)} name={`${firstName} ${lastName}`} />
        {next ? next() : null}
      </DwollaContainer>
    );
  }
  return (
    <>
      <Loader show={loading} />
      <Container css={(fullscreen && mobileMediaQuery) ? fullScreenCss : null} >
        {fullscreen || cancel && <Image onClick={() => {
          if (cancel) {
            cancel();
          } else {
            setFullscreen(false);
          }
        }} src={CloseIcon} />}
        <DwollaContainer id="iav-container" />
      </Container>
    </>
  );
}

export default Dwolla;